import { useState } from "react"
import { TabsItem, TabsItemProps } from "./TabsItem"

export const Tabs = ({
  tabs,
  defaultTabIndex = 0,
}: {
  tabs: Array<TabsItemProps>
  defaultTabIndex?: number
}) => {
  const [activeTab, setActiveTab] = useState(defaultTabIndex)
  const handleTabClick = (tabIndex: number) => {
    setActiveTab(tabIndex)
  }

  return (
    <ul className='text-gray-500 tw-grid tw-grid-flow-col tw-rounded tw-text-md tw-font-base tw-bg-gray-100 tw-p-1 tw-text-center'>
      {tabs.map((tab: TabsItemProps, index: number) => (
        <TabsItem
          key={tab?.key ?? String(index)}
          isActive={activeTab === index}
          onClick={() => {
            handleTabClick(index)
            tab?.onClickAction && tab?.onClickAction()
          }}
          {...tab}
        />
      ))}
    </ul>
  )
}
